import React from "react";
import ExchangeDifferenceCalculationsGenericSkeleton from "./ExchangeDifferenceCalculationsGenericSkeleton";

function ExchangeDifferenceCalculationsDetailSkeleton() {
  return (
    <>
      <ExchangeDifferenceCalculationsGenericSkeleton />
    </>
  );
}

export default ExchangeDifferenceCalculationsDetailSkeleton;
